export const addModalCatDropdownMap = {
  1: [
    { value: "1_1", label: "1.1 Stationary Combustion" },
    { value: "1_2", label: "1.2 Mobile Combustion" },
    {
      value: "1_3",
      label: "1.3 Direct GHG Emissions & Removals from Industrial Processes",
    },
    { value: "1_4", label: "1.4 Fugitive Emissions" },
    {
      value: "1_5",
      label: "1.5 Land Use, Land Use Change and Forestry (LULUCF)",
    },

    { value: "2_1", label: "2.1 Imported Electricity" },
    { value: "2_2", label: "2.2 Imported Energy" },

    {
      value: "3_1",
      label: "3.1 Upstream Transport and Distribution for Goods",
    },
    {
      value: "3_2",
      label: "3.2 Downstream Transport and Distribution for Goods",
    },
    { value: "3_3", label: "3.3 Employee Commuting" },
    { value: "3_4", label: "3.4 Client and Visitor Transport" },
    { value: "3_5", label: "3.5 Business Travel" },

    { value: "4_1", label: "4.1 Goods Purchased by an Organization" },
    {
      value: "4_2",
      label:
        "4.2 Capital Goods that are Purchased and Amortized by an Organization",
    },
    {
      value: "4_3",
      label:
        "4.3 Disposal Services (of solid or liquid waste) Used by an Organization",
    },
    {
      value: "4_4",
      label: "4.4 Use of Assets (through leased equipment) by an Organization",
    },
    {
      value: "4_5",
      label:
        "4.5 Use of Services not Described in the above sub-categories by an Organization",
    },

    { value: "5_1", label: "5.1 Use Stage of the Product" },
    { value: "5_2", label: "5.2 Downstream Leased Assets" },
    { value: "5_3", label: "5.3 End of Life Stage of the Product" },
    { value: "5_4", label: "5.4 Investments" },

    { value: "6_1", label: "6.1 Indirect GHG Emissions from other sources" },
  ],
  2: [
    // Scope 1: Direct Emissions
    { value: "1_1", label: "1.1 Direct Emissions from Stationary Combustion" },
    { value: "1_2", label: "1.2 Direct Emissions from Mobile Combustion" },
    { value: "1_3", label: "1.3 Direct Emissions from Process Sources" },
    { value: "1_4", label: "1.4 Direct Emissions from Fugitive Sources" },
    { value: "1_5", label: "1.5 Direct Emissions from Agricultural Sources" },

    // Scope 2: Indirect Emissions from Purchased Energy
    {
      value: "2_1",
      label: "2.1 Indirect Emissions from Purchased/Acquired Electricity",
    },
    {
      value: "2_2",
      label: "2.2 Indirect Emissions from Purchased/Acquired Steam",
    },
    {
      value: "2_3",
      label: "2.3 Indirect Emissions from Purchased/Acquired Heating",
    },
    {
      value: "2_4",
      label: "2.4 Indirect Emissions from Purchased/Acquired Cooling",
    },

    // Scope 3: Indirect Emissions from Up-and Downstream Transportation
    { value: "3_4", label: "3.4 Upstream Transportation and Distribution" },
    { value: "3_6", label: "3.6 Business Travel" },
    { value: "3_7", label: "3.7 Employee Commuting" },
    { value: "3_9", label: "3.9 Downstream Transportation and Distribution" },

    // Scope 3: Indirect Emissions from Upstream Activities
    { value: "3_1", label: "3.1 Purchased Goods and Services" },
    { value: "3_2", label: "3.2 Capital Goods" },
    {
      value: "3_3",
      label:
        "3.3 Fuel and Energy-related Activities(not included in Scope 1 or Scope 2)",
    },
    { value: "3_5", label: "3.5 Waste Generated in Operations" },
    { value: "3_8", label: "3.8 Upstream Leased Assets" },

    // Scope 3: Indirect Emissions from Downstream Activities
    { value: "3_10", label: "3.10 Processing of Solid Products" },
    { value: "3_11", label: "3.11 Use of Solid Products" },
    { value: "3_12", label: "3.12 End-of-Life Treatment of Solid Products" },
    { value: "3_13", label: "3.13 Downstream Leased Assets" },
    { value: "3_14", label: "3.14 Franchise (Scope 1 and Scope 2)" },
    { value: "3_15", label: "3.15 Investments" },
  ],
};